import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as House } from '../../assets/images/svg/house.svg';
import themeColors from '../../assets/styles/themeColors';

const HouseIconStyled = styled(House)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const HouseIcon = (props) => <HouseIconStyled {...props} />;

HouseIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

HouseIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default HouseIcon;
